import api from '@services/api.service'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'
import { AudioModel } from '@store/slices/audio.slice'
import { AxiosError } from 'axios'
import { DjangoErrorResponse } from '@store/slices/generic.slice'
import { toast } from 'react-toastify'
import { TimeslotModel } from '@store/slices/timeslot.slice'

const sectionEndpoint = 'time-slot/'

export const moveSlot = createAsyncThunk(
  'slot/move',
  async (props: { id: EntityId; newPosition: number }) => {
    try {
      const response = await api.post(
        `${sectionEndpoint}${props.id}/change-position/`,
        { position: props.newPosition }
      )

      return response.data.data as TimeslotModel[]
    } catch (error) {
      const axiosError = error as AxiosError
      if (axiosError.response) {
        const serverError = axiosError.response.data as DjangoErrorResponse
        toast.error(
          `Chyba: ${serverError.message || 'Nepodařilo se posunout slot'}`
        )
      } else {
        toast.error('Nepodařilo se posunout slot')
      }
      throw axiosError
    }
  }
)
